import axios from 'axios';
import { API_HOST } from '../../api_utils';
export const getPartnerEmployees = async (payload, token) => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.post(`${API_HOST}organisation/get-employees-partner`, payload, config);
  return response.data;
};


export const makeEmployeeAdmin = async (ordId,userId,action, token) => {

  const payload = {
    isAdmin:action
  }
  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.put(`${API_HOST}organisation/make-admin/${ordId}/${userId}`, payload, config);
  return response.data;
};

